export function getCreditCardType(cardNumber: string): string {
  const cleaned = cardNumber.replace(/\D/g, '');

  if (/^4\d{12}(\d{3})?(\d{3})?$/.test(cleaned)) return 'Visa';
  if (/^(5[1-5]\d{14}|2(2[2-9]|[3-6]\d|7[01])\d{12}|2720\d{12})$/.test(cleaned)) return 'MasterCard';
  if (/^3[47]\d{13}$/.test(cleaned)) return 'American Express';
  if (/^6(?:011|5\d{2}|4[4-9]\d)\d{12}$/.test(cleaned)) return 'Discover';
  if (/^3(?:0[0-5]|[68]\d)\d{11}$/.test(cleaned)) return 'Diners Club';
  if (/^35(2[89]|[3-8][0-9])\d{12,15}$/.test(cleaned)) return 'JCB';

  return 'Unknown';
}

export function getUrlParams(obj: any) {
  return Object.entries(obj)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&');
}
